define('presentation/common/snackbar/viewModels/snackbarViewModel',[

], function() {
    return function() {
        const self = this;

        let _settings = null;

        self.isActionSnackbar = ko.observable(false);
        self.isWarningSnackbar = ko.observable(false);

        self.isDismissible = ko.observable(false);

        self.onDismissCallback = null;

        self.onDismiss = () => {
            if (self.onDismissCallback) {
                self.onDismissCallback();
            }
        };

        self.activate = (settings) => {
            _settings = settings;
            return _initialize();
        };

        const _initialize = () => {
            if (_settings.hasOwnProperty('isActionSnackbar')) {
                self.isActionSnackbar(ko.unwrap(_settings.isActionSnackbar));
            }

            if (_settings.hasOwnProperty('isWarningSnackbar')) {
                self.isWarningSnackbar(ko.unwrap(_settings.isWarningSnackbar));
            }

            if (_settings.hasOwnProperty('isDismissible')) {
                // Held as the caller's observable rather than a snapshot: whether a snackbar can be
                // dismissed depends on what it is currently saying, which can change under it.
                if (ko.isObservable(_settings.isDismissible)) {
                    self.isDismissible = _settings.isDismissible;
                } else {
                    self.isDismissible(_settings.isDismissible);
                }
            }

            if (_settings.hasOwnProperty('onDismissCallback')) {
                self.onDismissCallback = _settings.onDismissCallback;
            }
        };
    };
});
